import {TableRow, TableCell, createTheme, TextField } from "@mui/material";

function CadastroChutes(infos) {
  const theme = createTheme({
    components: {
      // Name of the component
      MuiTableCell: {
        styleOverrides: {
          // Name of the slot
          root: {
            // Some CSS
            fontSize: '0.8rem',
            color: 'white',
            padding: '0',
            border: '0'
          }
        },
      },
    },
  });

  return (
    <>
        {infos.partidas.map((partidas) => (
            <TableRow key={partidas.ID}>
                <TableCell sx={{ maxWidth: 74 }} align="center" theme={theme}>{partidas.TIME1}</TableCell>
                {partidas.RESULTADO1 === -1
                  ? <TableCell sx={{ maxWidth: 50 ,  border: 1, borderColor: 'white'}} align="center" theme={theme}><TextField sx={{ input: { color: 'white', textAlign: 'center'} }} required type="number" id={partidas.ID} time='1' onChange={infos.funcao1} /></TableCell>
                  : <TableCell sx={{ maxWidth: 50 }} align="center" theme={theme}>{partidas.RESULTADO1}</TableCell>
                }
                <TableCell sx={{ maxWidth: 21 }} align="center" theme={theme}>X</TableCell>
                {partidas.RESULTADO2 === -1
                  ? <TableCell sx={{ maxWidth: 50 , border: 1, borderColor: 'white'}} align="center" theme={theme}><TextField sx={{ input: { color: 'white', textAlign: 'center'} }} required type="number" id={partidas.ID} onChange={infos.funcao2}/></TableCell>
                  : <TableCell sx={{ maxWidth: 50 }} align="center" theme={theme}>{partidas.RESULTADO2}</TableCell>
                }
                <TableCell sx={{ maxWidth: 74 }} align="center" theme={theme}>{partidas.TIME2}</TableCell>
            </TableRow>
        ))}
    </>
  );
}



export default CadastroChutes

